import React, { useState, useEffect } from 'react'
import PageHeader from '../../../components/common/PageHeader'
import BulkMessageForm from '../../../components/Form/BulkMessageForm'


const BulkMessage = () => {
  return (
    <>
      <PageHeader  title="Bulk Message" breadcrumbs={[ {label: 'Customer'}, {label: 'Bulk Message'}]}/>
      <BulkMessageForm/>
    </>
  )
}

export default BulkMessage